"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const AppContextProvider_1 = require("../../../../shared/contexts/AppContextProvider");
const FaqsAnswerModal_1 = __importDefault(require("./FaqsAnswerModal"));
const react_i18next_1 = require("react-i18next");
const MobileStyles_1 = require("./styles/MobileStyles");
const Faqs = () => {
    const { faqsData } = (0, AppContextProvider_1.useAppContext)();
    const [selectedFaq, setSelectedFaq] = (0, react_1.useState)(null);
    const [isOpen, setIsOpen] = (0, react_1.useState)(false);
    const { t } = (0, react_i18next_1.useTranslation)();
    const handleSelectFaq = (faq) => {
        setSelectedFaq(faq);
        setIsOpen(true);
    };
    return (react_1.default.createElement("div", { className: 'secaoBtnMobileFaq' },
        react_1.default.createElement(FaqsAnswerModal_1.default, { isOpen: isOpen, setIsOpen: setIsOpen, faq: selectedFaq, setFaq: setSelectedFaq }),
        react_1.default.createElement(MobileStyles_1.MobileButtonOrganizer, null, faqsData !== null ? faqsData.map((x) => (react_1.default.createElement(MobileStyles_1.MobileButton, { className: 'btn-generic--segundo ml-0', key: x.id, onClick: () => handleSelectFaq(x) }, x.titulo))) : '')));
};
exports.default = Faqs;
